(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["f1-product-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* ============== ATC → AJAX add + open cart drawer ============== */
  function init() {
    var form = document.getElementById('f1-product-form');
    if (!form || form.dataset.f1AtcWired === '1') return;
    form.dataset.f1AtcWired = '1';

    var btn = document.getElementById('f1BuyBtn');

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      if (btn && btn.disabled) return;
      var originalLabel = null;
      var ctaVerb = document.getElementById('f1CtaVerb');
      if (ctaVerb) {
        originalLabel = ctaVerb.textContent;
        ctaVerb.textContent = 'Adding…';
      }
      if (btn) btn.disabled = true;

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function(res) {
          return res.json().then(function(json) {
            if (!res.ok) throw json;
            return json;
          });
        })
        .then(function() {
          var done = function() {
            if (ctaVerb && originalLabel != null) ctaVerb.textContent = originalLabel;
            if (btn) btn.disabled = false;
            if (window.FrontierCart && typeof window.FrontierCart.open === 'function') {
              window.FrontierCart.open();
            } else {
              window.location.href = '/cart';
            }
          };

          if (window.FrontierCart && typeof window.FrontierCart.refresh === 'function') {
            window.FrontierCart.refresh(done);
          } else {
            done();
          }
        })
        .catch(function(err) {
          console.error('[f1-pdp ATC] add to cart failed', err);
          if (ctaVerb && originalLabel != null) ctaVerb.textContent = originalLabel;
          if (btn) btn.disabled = false;
          var msg = (err && err.description) || (err && err.message) || 'Could not add to cart.';
          alert(msg);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frontier-nav"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Solid nav on scroll */
  var nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('solid', window.scrollY > 40);
    }, { passive: true });
  }

  /* ============== CART DRAWER OPEN/CLOSE (shared) ============== */
  /* Try the host theme's own open mechanism first so it can fire its animation
     pipeline (the theme reveals [data-animation] elements via an observer).
     Falls back to a manual class toggle + a CSS override that forces content visible. */
  function openCartDrawer() {
    var cd = document.getElementById('cart-drawer');
    if (!cd) { window.location.href = '/cart'; return; }

    /* Dispatch theme events that some themes listen for (no navigation side-effect) */
    ['theme:cart:open', 'cart:open', 'cart:toggle'].forEach(function(name) {
      try { document.dispatchEvent(new CustomEvent(name, { bubbles: true })); } catch (e) {}
    });

    /* Manual open — class toggle. CSS override ensures content is visible. */
    cd.classList.add('is-open', 'drawer--animated');
    document.body.classList.add('js-drawer-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var cd = document.getElementById('cart-drawer');
    if (!cd) return;
    cd.classList.remove('is-open', 'drawer--animated');
    document.body.classList.remove('js-drawer-open');
    document.documentElement.style.overflow = '';
  }

  /* Expose globally so other sections (product page ATC) can open the drawer */
  window.FrontierCart = window.FrontierCart || {};
  window.FrontierCart.open = openCartDrawer;
  window.FrontierCart.close = closeCartDrawer;

  function updateCartCount(count) {
    var badges = document.querySelectorAll('[data-frontier-cart-count]');
    badges.forEach(function(el) {
      el.textContent = count;
      if (count > 0) {
        el.classList.remove('is-empty');
        el.classList.remove('bump');
        /* trigger reflow so animation can replay */
        void el.offsetWidth;
        el.classList.add('bump');
      } else {
        el.classList.add('is-empty');
      }
    });
    /* Also keep the in-drawer count in sync */
    var drawerCount = document.querySelector('[data-cart-count]');
    if (drawerCount) {
      drawerCount.textContent = count;
      drawerCount.setAttribute('data-cart-count', count);
    }
  }
  window.FrontierCart.updateCount = updateCartCount;

  /* Refresh cart drawer markup from the server, then run a callback */
  window.FrontierCart.refresh = function(cb) {
    var pageReq = fetch(window.location.pathname + window.location.search, { headers: { 'Accept': 'text/html' } })
      .then(function(r) { return r.text(); });
    var cartReq = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .catch(function() { return null; });

    Promise.all([pageReq, cartReq])
      .then(function(results) {
        var html = results[0];
        var cart = results[1];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('cart-drawer');
        var current = document.getElementById('cart-drawer');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          if (fresh.classList.contains('is-empty')) {
            current.classList.add('is-empty');
          } else {
            current.classList.remove('is-empty');
          }
        }
        if (cart && typeof cart.item_count === 'number') {
          updateCartCount(cart.item_count);
        }
        if (typeof cb === 'function') cb();
      })
      .catch(function() { if (typeof cb === 'function') cb(); });
  };

  window.addEventListener('load', function() {
    /* ---------- Hamburger drawer ---------- */
    var burger = document.getElementById('frontier-burger-btn');
    var drawer = document.querySelector('header-drawer[data-drawer^="hamburger-"]');
    if (burger && drawer) {
      var underlay = drawer.querySelector('.drawer__underlay');

      function openDrawer() {
        drawer.classList.add('is-open', 'drawer--animated');
        document.body.classList.add('js-drawer-open');
        document.documentElement.style.overflow = 'hidden';
      }
      function closeDrawer() {
        drawer.classList.remove('is-open', 'drawer--animated');
        document.body.classList.remove('js-drawer-open');
        document.documentElement.style.overflow = '';
      }

      burger.addEventListener('click', openDrawer);
      var closeBtn = drawer.querySelector('[data-drawer-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (underlay) underlay.addEventListener('click', closeDrawer);
    }

    /* ---------- Cart icon → open cart drawer ---------- */
    var cartLink = document.querySelector('.frontier-nav__cart');
    if (cartLink) {
      cartLink.addEventListener('click', function(e) {
        var cd = document.getElementById('cart-drawer');
        if (!cd) return; /* fall back to /cart navigation */
        e.preventDefault();
        openCartDrawer();
      });
    }

    /* ---------- Cart drawer close handlers (delegated, so they survive refresh) ---------- */
    document.addEventListener('click', function(e) {
      var t = e.target;
      if (!t) return;
      if (t.closest && (t.closest('[data-cart-drawer-close]') || t.closest('[data-drawer-underlay]'))) {
        var cd = document.getElementById('cart-drawer');
        if (cd && cd.contains(t)) {
          e.preventDefault();
          closeCartDrawer();
        }
      }
    });

    /* Close on ESC */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var cd = document.getElementById('cart-drawer');
        if (cd && cd.classList.contains('is-open')) closeCartDrawer();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frontier-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* ============== ATC → AJAX add + open cart drawer ============== */
  function init() {
    var form = document.getElementById('f1-product-form');
    if (!form || form.dataset.f1AtcWired === '1') return;
    form.dataset.f1AtcWired = '1';

    var btn = document.getElementById('f1BuyBtn');

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      if (btn && btn.disabled) return;
      var originalLabel = null;
      var ctaMain = document.getElementById('f1CtaMain');
      if (ctaMain) {
        originalLabel = ctaMain.textContent;
        ctaMain.textContent = 'Adding…';
      }
      if (btn) btn.disabled = true;

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function(res) {
          return res.json().then(function(json) {
            if (!res.ok) throw json;
            return json;
          });
        })
        .then(function() {
          var done = function() {
            if (ctaMain && originalLabel != null) ctaMain.textContent = originalLabel;
            if (btn) btn.disabled = false;
            if (window.FrontierCart && typeof window.FrontierCart.open === 'function') {
              window.FrontierCart.open();
            } else {
              window.location.href = '/cart';
            }
          };

          if (window.FrontierCart && typeof window.FrontierCart.refresh === 'function') {
            window.FrontierCart.refresh(done);
          } else {
            done();
          }
        })
        .catch(function(err) {
          console.error('[FRONTIER ATC] add to cart failed', err);
          if (ctaMain && originalLabel != null) ctaMain.textContent = originalLabel;
          if (btn) btn.disabled = false;
          var msg = (err && err.description) || (err && err.message) || 'Could not add to cart.';
          alert(msg);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
